import { Suspense } from 'react';
import ErrorBoundary from './ErrorBoundary';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
export const SuspenseBoundary = ({
  fallback,
  errorFallback,
  children
}) => {
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    fallback: errorFallback,
    children: /*#__PURE__*/_jsx(Suspense, {
      fallback: fallback || /*#__PURE__*/_jsx(LoadingSpinner, {}),
      children: children
    })
  });
};